import { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";

import { CustomTooltip } from "../tooltip/Tooltip";
import "./clipboard.scss";
import { copyIcon } from "../images";

function Clipboard({ text, showCopyIcon = true, ...props }) {
  const [copied, setCopied] = useState(false);

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      navigator.clipboard.writeText(text);
      handleCopy();
    }
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <CopyToClipboard
      text={text}
      style={{
        cursor: "pointer",
        height: props?.height,
        width: props?.width,
        outline: "none",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      {...props}
      onCopy={() => {
        handleCopy();
      }}
    >
      <CustomTooltip
        arrow={false}
        open={copied}
        placement={"top"}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        text={
          <>
            <CheckCircleSharpIcon />
            <span className="copied-clipboard-text">Copied</span>
          </>
        }
      >
        {props?.children}
        {showCopyIcon && (
          <img src={copyIcon} height={24} width={24} alt="copy icon" />
        )}
      </CustomTooltip>
    </CopyToClipboard>
  );
}

export default Clipboard;
